import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
import { fillVariants } from "../../../styles";
export const SolanaLogoSquare = t0 => {
  const $ = _c(23);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const gradientId = useId();
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <stop offset="8%" stopColor="#9945FF" />;
    t4 = <stop offset="30%" stopColor="#8752F3" />;
    t5 = <stop offset="50%" stopColor="#5497D5" />;
    t6 = <stop offset="60%" stopColor="#43B4CA" />;
    t7 = <stop offset="72%" stopColor="#28E0B9" />;
    t8 = <stop offset="97%" stopColor="#19FB9B" />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[12] !== gradientId) {
    t9 = <defs><linearGradient id={gradientId} x1="8.441%" x2="88.112%" y1="89.766%" y2="9.441%">{t3}{t4}{t5}{t6}{t7}{t8}</linearGradient></defs>;
    $[12] = gradientId;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <rect fill="#121212" height={24} rx={0} width={24} />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = `url(#${gradientId})`;
  let t12;
  if ($[15] !== t11) {
    t12 = <g fill="none" fillRule="nonzero">{t10}<path d="m13.779 9.514-2.287 2.389a.531.531 0 0 1-.388.164H.265a.27.27 0 0 1-.145-.042.252.252 0 0 1-.049-.393L2.36 9.244a.531.531 0 0 1 .388-.165h10.838a.27.27 0 0 1 .145.043.253.253 0 0 1 .049.393Zm-2.287-4.81a.531.531 0 0 0-.388-.164H.265a.27.27 0 0 0-.145.042.253.253 0 0 0-.049.393L2.36 7.363a.531.531 0 0 0 .388.165h10.838a.27.27 0 0 0 .145-.043.253.253 0 0 0 .049-.393l-2.287-2.388ZM.265 2.988h10.839a.544.544 0 0 0 .388-.164L13.78.435a.256.256 0 0 0 .049-.28.261.261 0 0 0-.098-.113.27.27 0 0 0-.145-.042H2.747a.543.543 0 0 0-.388.164L.072 2.554a.256.256 0 0 0-.05.278.26.26 0 0 0 .098.114.27.27 0 0 0 .145.042Z" fill={t11} transform="translate(5.075 5.965)" /></g>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== className || $[18] !== rest || $[19] !== t12 || $[20] !== t2 || $[21] !== t9) {
    t13 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t9}{t12}</svg>;
    $[17] = className;
    $[18] = rest;
    $[19] = t12;
    $[20] = t2;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};
export const SolanaLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0Zm19.153 15.503-2.287-2.389a.531.531 0 0 0-.388-.164H5.64a.27.27 0 0 0-.145.043.253.253 0 0 0-.049.393l2.287 2.388a.531.531 0 0 0 .388.165h10.838a.27.27 0 0 0 .145-.042.252.252 0 0 0 .049-.393Zm-2.287-4.81a.531.531 0 0 1-.388-.164H5.64a.27.27 0 0 1-.145-.043.253.253 0 0 1-.049-.393l2.287-2.388a.531.531 0 0 1 .388-.165h10.838a.27.27 0 0 1 .145.042.253.253 0 0 1 .049.393l-2.287 2.389Zm.388-5.989H6.416a.544.544 0 0 0-.388.164L3.742 7.258a.256.256 0 0 0-.05.278.26.26 0 0 0 .098.114.27.27 0 0 0 .145.042h10.838a.543.543 0 0 0 .388-.164l2.287-2.39a.256.256 0 0 0 .049-.28.261.261 0 0 0-.098-.113.27.27 0 0 0-.145-.042Z" fill={fillAttribute} fillRule="nonzero" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};